import React from "react";
import AllSubjectTopics from "../../../topics/AllSubjectTopics";


function NcertSolutionChemTopics() {
  return (
    <>

      <AllSubjectTopics  subject="chemistry" type="ncertsolution" />


    </>
  );
}

export default NcertSolutionChemTopics;